import React from "react";
import "./PatientFlowStepper.scss";

/**
 * Shared step config for the patient treatment flow. Use with class `patient-flow-stepper`
 * on the root element for consistent multi-step form styling.
 */
export function buildPatientFlowSteps(t) {
  return [
    { label: t("flowStepDocuments"), shortLabel: t("flowStepShort1") },
    { label: t("flowStepReports"), shortLabel: t("flowStepShort2") },
    { label: t("flowStepInsurance"), shortLabel: t("flowStepShort3") },
    { label: t("flowStepCategory"), shortLabel: t("flowStepShort4") },
  ];
}

export default function PatientFlowStepper({
  steps,
  activeStep,
  onStepClick,
  extraClass = "",
}) {
  return (
    <div
      className={`stepper patient-flow-stepper ${extraClass}`.trim()}
      role="list"
      aria-label="Patient progress"
    >
      {steps.map((step, index) => {
        const status =
          index < activeStep ? "done" : index === activeStep ? "active" : "todo";
        const canClick = typeof onStepClick === "function";
        const isCurrent = index === activeStep;

        return (
          <div
            className="step"
            data-status={status}
            key={index}
            role="listitem"
            onClick={() => canClick && onStepClick(index)}
            style={{ cursor: canClick ? "pointer" : "default" }}
            aria-current={isCurrent ? "step" : undefined}
            aria-label={`${step.label} (${status})`}
          >
            {index !== steps.length - 1 && <span className="line" />}

            <div className="dot">
              {status === "done" ? (
                <span className="tickMark">✓</span>
              ) : (
                <span className="stepNum">{index + 1}</span>
              )}
            </div>

            <p className="label">
              <span className="label-full">{step.label}</span>
              <span className="label-short">{step.shortLabel || step.label}</span>
            </p>
          </div>
        );
      })}
    </div>
  );
}
